import {createContext} from 'react'

import {noop} from '../../../../../utils/empty'

type QueueSidebarSearchContextValue = {
  searchQuery: string
  searchActive: boolean
  changeSidebarSearchQuery: (query: string) => void
  changeSidebarSearchActive: (active: boolean) => void
}

export const QueueSidebarSearchContext = createContext<QueueSidebarSearchContextValue>({
  searchQuery: '',
  searchActive: false,
  changeSidebarSearchQuery: noop,
  changeSidebarSearchActive: noop,
})
